import React, { Component } from "react";
import DetailPatient from "../form/DetailPatient.js";
import { Route, Switch, Link } from "react-router-dom";
import { modules } from "../../routes";
import { DetilPxContext } from "../../context";
import Alergi from "../form/Alergi";

class PelayananPx extends Component {
  static contextType = DetilPxContext;
  constructor(props) {
    super(props);
    this.state = {
      modules: [
        { id: "1", name: "Subjektif" },
        { id: "2", name: "Objektif" },
        { id: "3", name: "Assesment" },
        { id: "4", name: "Planning" },
      ],
      visible: false,
    };
  }

  buttonClick = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    var patient = this.context.data;
    console.log(patient);
    return (
      <div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="col-xl-3 order-xl-1">
                  <DetailPatient patient={patient} />
                  <div className="card">
                    <div className="card-header">
                      <h4>Modul</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {modules.map((modul) => {
                          if (modul.menu === "pelayananObat") {
                            // if(patient.clinic_id === modul.clinicId){
                            return (
                              <div key={modul.moduleId} className="col-6">
                                <Link
                                  style={{
                                    whiteSpace: "normal",
                                    paddingLeft: "2Px",
                                    paddingRight: "2Px",
                                  }}
                                  className="btn btn-primary btn-block"
                                  to={this.props.match.url + modul.path}
                                  key={modul.moduleId}
                                >
                                  {modul.name}
                                </Link>
                                <br></br>
                              </div>
                            );
                            // }
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-9 order-xl-2">
                  <div className="card">
                    <Alergi patient={patient} />
                  </div>
                  <Switch>
                    {modules.map(({ component: Component, ...rest }, key) => {
                      // if(patient.clinic_id === rest.clinicId){
                      return (
                        <Route
                          path={this.props.match.url + rest.path}
                          render={(props) => (
                            <Component {...props} detilPx={patient} />
                          )}
                          key={key}
                        />
                      );
                      // }
                    })}
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PelayananPx;
